import { render, staticRenderFns } from "./CustomerGroupsView.vue?vue&type=template&id=b9172d9e&"
import script from "./CustomerGroupsView.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroupsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports